import { Component, Input } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Utils } from "../../utils/utils";
import { Retrospective } from "../../interfaces/retrospective";
import { RiskIndicator } from "../../interfaces/riskIndicator";

@Component({
  selector: "app-retrospective-wizard-1-start",
  templateUrl: "./retrospective-wizard-1-start.component.html",
  styleUrls: ["./retrospective-wizard-1-start.component.scss"],
})
export class RetrospectiveWizardStartComponent extends MzBaseModal {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() retrospective: Retrospective;
  @Input() retrospectives: Retrospective[];
  @Input() riskIndicators: RiskIndicator[];
  @Input() riskIndicatorSelection: {};

  date: Date = new Date();
  canCreate: boolean;
  error: string;
  result: boolean;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  async show(): Promise<boolean> {
    this.modalComponent.open();
    this.result = undefined;
    this.modalComponent.open();
    await this.modalComponent.onClose
      .map((_) => true)
      .first()
      .toPromise();
    return this.result;
  }

  async validateName(newValue) {
    let nameNotEmpty = newValue && newValue.trim() !== "";
    let nameAlreadyExists =
      this.retrospectives &&
      this.retrospectives.filter(
        (x) =>
          x.name.localeCompare(newValue, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    let selectedRiskIndicators = Object.keys(
      this.riskIndicatorSelection
    ).filter((x) => this.riskIndicatorSelection[x]);
    this.canCreate =
      nameNotEmpty && !nameAlreadyExists && selectedRiskIndicators.length > 0;
    this.error = nameAlreadyExists
      ? "Eine Retrospektive mit diesem Namen existiert bereits."
      : null;
  }

  async validateCheckbox() {
    let nameNotEmpty =
      this.retrospective.name && this.retrospective.name.trim() !== "";
    let nameAlreadyExists =
      this.retrospectives &&
      this.retrospectives.filter(
        (x) =>
          x.name.localeCompare(this.retrospective.name, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    let selectedRiskIndicators = Object.keys(
      this.riskIndicatorSelection
    ).filter((x) => this.riskIndicatorSelection[x]);
    this.canCreate =
      nameNotEmpty && !nameAlreadyExists && selectedRiskIndicators.length > 0;
    this.error = nameAlreadyExists
      ? "Eine Retrospektive mit diesem Namen existiert bereits."
      : null;
  }

  confirm() {
    if (this.canCreate) {
      this.result = true;
      this.modalComponent.close();
    }
  }

  close() {
    this.result = false;
    this.canCreate = false;
    this.modalComponent.close();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/retrospective-wizard-1-start/retrospective-wizard-1-start.component.ts